import * as CookieConsent from 'vanilla-cookieconsent';

export const Datenschutz = () => (
  <>
    <section className="page-hero page-hero--small" id="top">
      <div className="container page-hero__inner">
        <div>
          <span className="section__eyebrow">Rechtliche Angaben</span>
          <h1>Datenschutzerklärung</h1>
          <p className="page-hero__lead">
            Informationen zur Verarbeitung personenbezogener Daten nach der
            Datenschutz-Grundverordnung (DS-GVO).
          </p>
        </div>
      </div>
    </section>

    <section className="section legal">
      <div className="container">
        <div className="grid gap-4">
          <div className="legal-accordion__actions">
            <button
              className="legal-accordion__button"
              type="button"
              onClick={() => {
                document
                  .querySelectorAll<HTMLDetailsElement>('.legal-accordion')
                  .forEach((item) => {
                    item.open = true;
                  });
              }}
            >
              Alles öffnen
            </button>
            <button
              className="legal-accordion__button legal-accordion__button--ghost"
              type="button"
              onClick={() => {
                document
                  .querySelectorAll<HTMLDetailsElement>('.legal-accordion')
                  .forEach((item) => {
                    item.open = false;
                  });
              }}
            >
              Alles schließen
            </button>
          </div>
          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>1. Verantwortlicher</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p className="font-semibold text-slate-900 dark:text-white">Staisch Innovative Elektrotechnik</p>
              <p>Inhaber: Adrian Staisch</p>
              <p>Elektrotechniker-Meister</p>
              <p>
                Freiherr-vom-Stein-Straße 14
                <br />
                72654 Neckartenzlingen
              </p>
              <p>
                Telefon:{' '}
                <a className="font-medium text-blue-600 hover:underline" href="tel:015758166291">
                  01575 8166291
                </a>
              </p>
              <p>
                E-Mail:{' '}
                <a
                  className="font-medium text-blue-600 hover:underline"
                  href="mailto:info@staisch-elektrotechnik.de"
                >
                  info@staisch-elektrotechnik.de
                </a>
              </p>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>2. Allgemeine Hinweise zur Datenverarbeitung</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p>
                Wir verarbeiten personenbezogene Daten ausschließlich, soweit dies zur Bereitstellung
                einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist.
                Die Verarbeitung erfolgt auf Grundlage der DS-GVO, des BDSG sowie weiterer
                einschlägiger Vorschriften.
              </p>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>3. Besuch der Website & Server-Logfiles</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p>
                Bei jedem Aufruf unserer Website erfasst unser System automatisch Daten und Informationen
                vom Computersystem des aufrufenden Rechners (Server-Logfiles). Erfasst werden unter
                anderem IP-Adresse, Datum und Uhrzeit des Zugriffs, URL der aufgerufenen Seite,
                Herkunfts-URL sowie Informationen zu Browser und Betriebssystem.
              </p>
              <p>
                Die Daten werden in den Logfiles unseres Systems gespeichert. Eine Speicherung dieser
                Daten zusammen mit anderen personenbezogenen Daten findet nicht statt. Rechtsgrundlage
                ist Art. 6 Abs. 1 lit. f DS-GVO. Unser berechtigtes Interesse liegt in der Sicherstellung
                der Funktionsfähigkeit und Sicherheit der Website.
              </p>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>4. Cookies und Cookie-Einwilligung (CookieConsent)</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p>
                Unsere Website setzt ein Consent-Management-Tool ein, um Ihre Einwilligung zur Speicherung
                bestimmter Cookies auf Ihrem Endgerät oder zum Einsatz bestimmter Technologien einzuholen
                und diese datenschutzkonform nach Art. 6 Abs. 1 lit. c DS-GVO zu dokumentieren.
              </p>
              <p>
                Technisch notwendige Cookies werden auf Grundlage von § 25 Abs. 2 TDDDG bzw. Art. 6 Abs. 1 lit. f DS-GVO
                gespeichert, um grundlegende Funktionen der Website bereitzustellen. Optionale Analyse-Cookies
                werden nur mit Ihrer ausdrücklichen Einwilligung gemäß Art. 6 Abs. 1 lit. a DS-GVO und § 25 Abs. 1 TDDDG
                aktiviert.
              </p>
              <p>
                Sie können Ihre erteilte Einwilligung jederzeit widerrufen oder Ihre Cookie-Präferenzen mit Wirkung für die Zukunft
                ändern:
              </p>
              <div className="mt-4">
                <button
                  type="button"
                  className="btn btn--primary"
                  onClick={() => CookieConsent.showPreferences()}
                >
                  Cookie-Einstellungen öffnen
                </button>
              </div>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>5. Kontaktformular</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p>
                Wenn Sie uns über das bereitgestellte Formular kontaktieren, verarbeiten wir die von
                Ihnen eingegebenen Daten (Name, E-Mail-Adresse, Telefonnummer, Nachricht) zur
                Bearbeitung Ihrer Anfrage. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DS-GVO. Die Daten
                werden gelöscht, sobald sie für die Bearbeitung nicht mehr erforderlich sind.
              </p>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>6. Kommunikation per E-Mail oder Telefon</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p>
                Nehmen Sie per E-Mail oder Telefon Kontakt mit uns auf, speichern wir die übermittelten
                Daten, soweit dies zur Bearbeitung und für eventuelle Anschlussfragen erforderlich ist.
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DS-GVO.
              </p>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>7. Einbindung von Diensten und Inhalten Dritter</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p>
                Auf einzelnen Seiten binden wir Kartenmaterial von Google Maps ein. Anbieter ist Google
                Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Durch die Nutzung von
                Google Maps können Informationen über Ihre Benutzung dieser Website an Google übertragen
                werden. Weitere Informationen finden Sie in der Datenschutzerklärung von Google:{' '}
                <a
                  className="font-medium text-blue-600 hover:underline"
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://policies.google.com/privacy
                </a>
                .
              </p>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>8. Weitergabe von Daten</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p>
                Eine Übermittlung Ihrer persönlichen Daten an Dritte findet nur statt, wenn dies zur
                Vertragserfüllung erforderlich ist, wir gesetzlich dazu verpflichtet sind oder Sie zuvor
                eingewilligt haben.
              </p>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>9. Speicherdauer</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p>
                Wir verarbeiten und speichern personenbezogene Daten nur für den Zeitraum, der zur
                Erreichung des Speicherzwecks erforderlich ist oder sofern dies durch gesetzliche
                Vorschriften vorgesehen wurde.
              </p>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>10. Ihre Rechte</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <ul className="list-disc space-y-1 pl-5">
                <li>Recht auf Auskunft nach Art. 15 DS-GVO</li>
                <li>Recht auf Berichtigung nach Art. 16 DS-GVO</li>
                <li>Recht auf Löschung nach Art. 17 DS-GVO</li>
                <li>Recht auf Einschränkung der Verarbeitung nach Art. 18 DS-GVO</li>
                <li>Recht auf Datenübertragbarkeit nach Art. 20 DS-GVO</li>
                <li>Recht auf Widerspruch nach Art. 21 DS-GVO</li>
                <li>Recht auf Beschwerde bei einer Aufsichtsbehörde (Art. 77 DS-GVO)</li>
              </ul>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>11. Widerruf von Einwilligungen</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p>
                Sie können eine erteilte Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.
                Die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung
                bleibt vom Widerruf unberührt.
              </p>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>12. Datensicherheit</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p>
                Wir treffen technische und organisatorische Maßnahmen, um Ihre Daten vor Verlust,
                Zerstörung, Manipulation oder unberechtigtem Zugriff zu schützen. Unsere
                Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend
                verbessert.
              </p>
            </div>
          </details>

          <details className="legal-accordion">
            <summary className="legal-accordion__summary">
              <span>13. Aktualität und Änderung dieser Datenschutzerklärung</span>
              <span className="legal-accordion__icon" aria-hidden="true">›</span>
            </summary>
            <div className="legal-accordion__content">
              <p>
                Diese Datenschutzerklärung hat den Stand März 2024. Durch die Weiterentwicklung
                unserer Website oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann
                es notwendig werden, diese Erklärung anzupassen.
              </p>
            </div>
          </details>
        </div>
      </div>
    </section>
  </>
);
